import { createI18n } from '@learnforge/i18n';
import { locales, type MechKey } from './locales';

export const i18n = createI18n<MechKey>({
  gameId: 'mechanics',
  locales,
});

export type { MechKey };
